import * as React from "react";

/**
 * The `open` a popup root is handed, so that a root mounted ALREADY open
 * still enters the way a trigger's open does.
 *
 * Base UI stamps `data-starting-style` only on a false→true flip of `open`;
 * a root that mounts with `open` already true never flips, so its popup
 * paints straight at rest with no enter transition. A dialog merely skips
 * its fade. A bottom drawer is worse: its rest is `translateY(var(
 * --drawer-snap-point-offset))`, and the offset is `0px` for the commit
 * that mounts the popup (Base UI measures the popup's height in a layout
 * effect, and measuring reads layout, which pins that first style as the
 * transition's start), so a half sheet lands over the WHOLE screen and then
 * slides down to its stop — "the sheet jumps in from the top". The consumer
 * mounts the dialog on demand (`{issue && <UpdateAgeDialog open />}`), a
 * shape every conditional dialog takes, so the host absorbs it.
 *
 * Holding `open` false for the mount commit and releasing it in a layout
 * effect — before the first paint — turns the mount-open into the ordinary
 * flip: the popup mounts under `data-starting-style`, offset measured, and
 * rides its own transition in. Nothing paints between the two commits.
 */
export function useEnterOnMount(open: boolean | undefined): boolean | undefined {
  const [held, setHeld] = React.useState(open === true);
  React.useLayoutEffect(() => {
    if (held) setHeld(false);
  }, [held]);
  return held ? false : open;
}
